import { PM_Handle_PicQueue } from "./PM_Handle_PicQueue.js";

export function PM_Handle_PicQueue_Start(picMgr) {
  PM_Handle_PicQueue(picMgr);
}
